// extracted by mini-css-extract-plugin
export default {"default":"page-wrapper_default__-LvQw","flex":"page-wrapper_flex__odG2f","shrink":"page-wrapper_shrink__AO0ae","fullScreenHeight":"page-wrapper_fullScreenHeight__tsyzG"};